import { createReducer } from '@reduxjs/toolkit'

import { defaultLanguage } from 'shared/locale'

import * as actions from '../actions'
import { IUserSettingsState } from '../types'

const initialState: IUserSettingsState = {
  data: {
    lang: defaultLanguage,
    isChanged: false,
    direction: 'ltr',
  },
}

export default createReducer(initialState, builder => {
  builder.addCase(actions.changeLang.fulfilled, (state, action) => {
    state.data.lang = action.payload.lang
    state.data.direction = action.payload.direction
    state.data.isChanged = true
  })
})
